import ApplicationAdapter from 'volta/_pods/application/adapter';


type PlanningSupplyAlternativeQuery = Record<string, unknown> & {
  skuId?: string;
};

export default class PlanningSupplyAlternativeAdapter extends ApplicationAdapter {
  urlForQuery(query: PlanningSupplyAlternativeQuery, modelName: string): string {
    const { skuId } = query;

    if (!skuId) {
      return super.urlForQuery(query, modelName);
    }

    delete query.skuId;

    return this.buildRawURL(`plannings/alternatives/${skuId}`);
  }
}
